// removed by extract-text-webpack-plugin
module.exports = {"exceptionRow":"yddzZWVv5mdtxc2Du0CN","exception":"_1SfBtzk7SNHg5i61SkNtFL","trace":"_35hPMey5qs2CeDvVabYjNp"};


//////////////////
// WEBPACK FOOTER
// ./js/Components/Exception.less
// module id = 166
// module chunks = 0